"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fabricateMarketClaimRewards = void 0;
const terra_js_1 = require("@terra-money/terra.js");
const address_1 = require("../../utils/validation/address");
const validate_input_1 = require("../../utils/validate-input");
const true_1 = require("../../utils/validation/true");
/**
 *
 * @param address Client’s Terra address.
 * @param market Type of stablecoin money market to borrow.
 * @param to (optional) Terra address to withdraw rewards. If null, withdraws to address
 */
const fabricateMarketClaimRewards = ({ address, market, to }) => (addressProvider) => {
    (0, validate_input_1.validateInput)([
        (0, address_1.validateAddress)(address),
        to ? (0, address_1.validateAddress)(to) : true_1.validateTrue,
    ]);
    const mmContractAddress = addressProvider.market(market);
    return [
        new terra_js_1.MsgExecuteContract(address, mmContractAddress, {
            claim_rewards: {
                to: to,
            },
        }),
    ];
};
exports.fabricateMarketClaimRewards = fabricateMarketClaimRewards;
//# sourceMappingURL=market-claim-rewards.js.map